import { z } from 'zod'

export const RELOAD_MARKER_KEY = 'rp.update.reload'
export const RELOAD_MARKER_TTL_MS = 60_000

const Marker = z.object({ buildId: z.string().min(1), at: z.number().finite() })

type MarkerStorage = Pick<Storage, 'getItem' | 'setItem'>

const NO_STORAGE: MarkerStorage = { getItem: () => null, setItem: () => undefined }

export const sessionMarkerStorage = (): MarkerStorage => {
  try {
    return window.sessionStorage
  } catch {
    return NO_STORAGE
  }
}

const readMarker = (storage: Pick<Storage, 'getItem'>): z.infer<typeof Marker> | null => {
  try {
    const raw = storage.getItem(RELOAD_MARKER_KEY)
    if (raw === null) return null
    const parsed = Marker.safeParse(JSON.parse(raw))
    return parsed.success ? parsed.data : null
  } catch {
    return null
  }
}

export const recordReload = (storage: Pick<Storage, 'setItem'>, buildId: string, now: Date): void => {
  try {
    storage.setItem(RELOAD_MARKER_KEY, JSON.stringify({ buildId, at: now.getTime() }))
  } catch {
    return
  }
}

export const isReloadRecent = (storage: Pick<Storage, 'getItem'>, buildId: string, now: Date): boolean => {
  const marker = readMarker(storage)
  if (marker === null || marker.buildId !== buildId) return false
  const elapsedMs = now.getTime() - marker.at
  return elapsedMs >= 0 && elapsedMs < RELOAD_MARKER_TTL_MS
}
